import apis from "../../../utils/apis";
import { showFeedbackModal } from "../UserFeedbackActions";
import { AppThunk } from '../../types';
import { handleApiError } from '../utils/utils';
import { DraftType } from "../../../components/shared/Drafts/DraftTemplateManager";

export const fetchDraftTypes = () => async (dispatch: any) => {
  try {
    const response = await apis.get('/draft/types');
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const fetchCaseDraftTypes = (caseId: string) => async (dispatch: any) => {
  try {
    const response = await apis.get(`/cases/${caseId}/drafttypes`);
    return response.data as DraftType[];
  } catch (error) {
    throw error;
  }
};

export const updateCaseDraftTypes = (caseId: string, draftTypes: number[]) => async (dispatch: any) => {
  try {
    const response = await apis.post(`/cases/${caseId}/drafttypes`, { drafttypes: draftTypes });
    dispatch(showFeedbackModal({
      showModal: true,
      message: 'Draft types updated successfully!',
      modalType: 'success',
      duration: 3000,
    }));
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const fetchDraftTemplates = () => async (dispatch: any) => {
  try {
    const response = await apis.get('/draft/templates');
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const createDraftTemplate = (template: { name: string; description: string; draftTypeIds: number[] }) => async (dispatch: any) => {
  try {
    const response = await apis.post('/draft/templates', template);
    dispatch(showFeedbackModal({
      showModal: true,
      message: 'Template created successfully!',
      modalType: 'success',
      duration: 3000,
    }));
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const updateDraftTemplate = (templateId: number, template: { name: string; description: string; draftTypeIds: number[] }) => async (dispatch: any) => {
  try {
    const response = await apis.put(`/draft/templates/${templateId}`, template);
    dispatch(showFeedbackModal({
      showModal: true,
      message: 'Template updated successfully!',
      modalType: 'success',
      duration: 3000,
    }));
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const deleteDraftTemplate = (templateId: number) => async (dispatch: any) => {
  try {
    const response = await apis.delete(`/draft/templates/${templateId}`);
    dispatch(showFeedbackModal({
      showModal: true,
      message: 'Template deleted successfully!',
      modalType: 'success',
      duration: 3000,
    }));
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Fetch draft type files
export const fetchDraftTypeFiles = (caseId: string, draftTypeName: string): AppThunk<Promise<any>> => {
  return async dispatch => {
    try {
      const response = await apis.get(`/cases/${caseId}/drafttypes/${draftTypeName}/files`);
      if (response.status === 200) {
        return response.data;
      } else {
        handleApiError(response, dispatch);
        return null;
      }
    } catch (err) {
      handleApiError(err, dispatch);
      return null;
    }
  };
};

// Upload draft type file
export const uploadDraftTypeFile = (caseId: string, draftTypeName: string, file: File): AppThunk<Promise<void>> => {
  return async dispatch => {
    try {
      const formData = new FormData();
      formData.append('file', file);
      const response = await apis.post(`/cases/${caseId}/drafttypes/${draftTypeName}/files`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      if (response.status === 200) {
        dispatch(showFeedbackModal({
          showModal: true,
          message: 'File uploaded successfully!',
          modalType: 'success',
          duration: 3000,
        }));
      } else {
        handleApiError(response, dispatch);
      }
    } catch (err) {
      handleApiError(err, dispatch);
    }
  };
};

export const updateDraftSettings = (values: any) => async (dispatch: any) => {
  try {
      const response = await apis({
        method: "POST",
        url: `/draft/settings/update`,
        data: values
      });
      if (response && response.status === 200){
        return response.data;
      }
      
  } catch (error) {
      handleApiError(error, dispatch)
      return null
  }
};

export const getDraftSettings = (caseId: string, draftId: number) => async (dispatch: any) => {
  try {
      const response = await apis.get(`/draft/${caseId}/${draftId}/settings`);
      return response.data;
  } catch (error) {
      throw error;
  }
};

export const setCustomInstruction = (caseId: string, draftId: number, instruction: string) => async (dispatch: any) => {
  try {
      const response = await apis.post(`/draft/${caseId}/${draftId}/custom_instruction`, { instruction });
      dispatch(showFeedbackModal({
          showModal: true,
          message: 'Custom instruction updated successfully!',
          modalType: 'success',
          duration: 3000,
      }));
      return response.data;
  } catch (error) {
      throw error;
  }
};

export const addDraftAttachment = (caseId: string, draftId: number, file: File) => async (dispatch: any) => {
  try {
      const formData = new FormData();
      formData.append('file', file);
      const response = await apis.post(`/draft/${caseId}/${draftId}/attachments`, formData, {
          headers: { 'Content-Type': 'multipart/form-data' },
      });
      dispatch(showFeedbackModal({
          showModal: true,
          message: 'Attachment added successfully!',
          modalType: 'success',
          duration: 3000,
      }));
      return response.data;
  } catch (error) {
      throw error;
  }
};

export const removeDraftAttachment = (caseId: string, draftId: number, attachmentIndex: number) => async (dispatch: any) => {
  try {
      const response = await apis.delete(`/draft/${caseId}/${draftId}/attachments/${attachmentIndex}`);
      dispatch(showFeedbackModal({
          showModal: true,
          message: 'Attachment removed successfully!',
          modalType: 'success',
          duration: 3000,
      }));
      return response.data;
  } catch (error) {
      throw error;
  }
};
